import React, { useMemo } from "react";
import useObjectInput from "../../../hooks/useObjectInput";

const ErrorDetailDisplay = ({
  errorDetail,
  index,
  detailedErrorLog,
  convertTime,
  highlight,
  handleStopHighlight,
  handleHighlight,
  handleRuleBrokenObject,
  highlightData,
}) => {
  const timeDifference = useMemo(
    () => new Date() - new Date(errorDetail?.time),
    [errorDetail?.time]
  );

  const disableErrorButton =
    highlight &&
    (highlightData.objectId !== errorDetail.errorAtObjectId ||
      highlightData.uniqueId !== errorDetail.uniqueId);

  return (
    <div key={index}>
      <div className="goi-errors-display-info-wrapper">
        <div className="goi-errors-time-info">
          <p>{convertTime(timeDifference)}</p>
          <p>{errorDetail?.failCondition}</p>
        </div>
        <div className="goi-error-hint-wrapper">
          <div className="goi-errors-display-hint">
            <p>
              {errorDetail.ref && <span>[{errorDetail?.ref}]</span>}{" "}
              {errorDetail?.hint}
            </p>
          </div>
          {errorDetail?.type === "objectValidation" && (
            <div className="goi-errors-scroll-button-wrapper">
              <button
                id={errorDetail.uniqueId}
                key={errorDetail.unableToUpdateObjectIds}
                onClick={highlight ? handleStopHighlight : handleHighlight}
                disabled={disableErrorButton}
              >
                {highlight &&
                highlightData.uniqueId === errorDetail.uniqueId &&
                highlightData.objectId === errorDetail.errorAtObjectId
                  ? "stop Highlight"
                  : "Highlight"}
              </button>
              <button
                className={errorDetail.errorAtObjectId}
                id={errorDetail.uniqueId}
                key={errorDetail.errorAtObjectId}
                onClick={handleRuleBrokenObject}
                disabled={disableErrorButton}
              >
                Go to Rule-broken Object
              </button>
              {/* )} */}
            </div>
          )}
        </div>

        <div className="goi-errors-detail-info-wrapper">
          {errorDetail?.rule && (
            <div className="goi-errors-detail-info-inner-triggered">
              <p>Triggered rule:</p>
              <p>{errorDetail?.rule}</p>
            </div>
          )}
          {errorDetail?.object && (
            <div className="goi-errors-detail-info-inner-object">
              <p>Error at Object:</p>
              <p>{errorDetail?.object}</p>
            </div>
          )}
          {!!errorDetail.dependencies?.length && (
            <div className="goi-errors-detail-info-inner-dependencies">
              <p>Dependencies:</p>
              {errorDetail.dependencies?.map((dependency, index) => (
                <p key={index}>{dependency.name}</p>
              ))}
            </div>
          )}
        </div>
      </div>
      {errorDetail?.apiNo !== detailedErrorLog[index + 1]?.apiNo &&
        index < detailedErrorLog.length - 1 && (
          <div className="goi-errors-display-wrapper"></div>
        )}
    </div>
  );
};

// Renders the error section, and loops through the detailedErrorLog and displays the error details
const ErrorDetail = ({
  highlight,
  convertTime,
  handleStopHighlight,
  handleShowHighlight,
  handleRuleBrokenObject,
}) => {
  const { detailedErrorLog, highlightData } = useObjectInput();

  return (
    <div className="goi-detailed-error-map-wrapper">
      {detailedErrorLog.map((errorDetail, index) => (
        <ErrorDetailDisplay
          key={errorDetail.uniqueId} // Replace with unique identifier
          errorDetail={errorDetail}
          index={index}
          detailedErrorLog={detailedErrorLog}
          convertTime={convertTime}
          highlight={highlight}
          handleStopHighlight={handleStopHighlight}
          handleHighlight={handleShowHighlight}
          handleRuleBrokenObject={handleRuleBrokenObject}
          highlightData={highlightData}
        />
      ))}
    </div>
  );
};

export default ErrorDetail;
